import { Container, Grid, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../../../../styles/img/df-logo.png";
import { CloseIcon } from "../../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../../styles/img/svg/BackIcon";
import { ResetPasswordForm } from "../../Forms/ResetPasswordForm";
import { ResetPasswordSuccess } from "../ForgotPassword/ResetPasswordSuccess";
import { useDispatch } from "react-redux";
import { setForgotPasswordScreenType } from "../../../../../_redux/_actions";
import { commonConstants } from "../../../../../_redux/_constants";
import { ForgotUserNameLeavePopup } from "../../../ForgotUsername/popups/forgotUserNameLeavePopup";
import { UiPopup } from "../../../../_uiComponents/common/UiModal";
import { ConfirmationIcon } from "../../../../../styles/img/svg/ConfirmationIcon";
export const ResetPassword = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);
  const navigate = useNavigate();

  const handleNameChange = (e) => {
    setDisplayName(e.target.value);
    setShowActionButtons(true);
  };

  const backtoHome = () => {
    setShowLeavingPopup(true);
  };

  const okBtnHandler = () => {
    navigate("/");
  };

  const backtoResetUsername = () => {
    dispatch(
      setForgotPasswordScreenType(
        commonConstants.FORGOT_PASSWORD_ACCOUNT_DETAILS_SCREEN,
      ),
    );
  };

  return (
    <>
      <div className="df-user-profile df-reset-cd-form df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={backtoHome}>
            <CloseIcon />
          </div>

          <div
            className="df-user-profile__back-icon"
            onClick={backtoResetUsername}
          >
            <BackIcon />
          </div>

          <div className="df-user-profile__body df-pw-tab df-card-details-tb df-pw-reset-tb">
            <Grid container>
              <Grid size={12} className="text-right df-pl-2">
                <h2 className="df-reset-pw-title text-center">
                  {t("Enter a password for your digital banking account")}
                </h2>
                <ResetPasswordForm />
              </Grid>
            </Grid>
          </div>
        </Container>
        <UiPopup
          openModal={showLeavingPopup}
          handleClose={() => {
            setShowLeavingPopup(false);
          }}
        >
          <ForgotUserNameLeavePopup
            icon={<ConfirmationIcon />}
            message={t("Leaving this page?")}
            buttonText={t("Leave")}
            buttonOnClickClose={() => {
              setShowLeavingPopup(false);
            }}
            buttonOnClick={okBtnHandler}
            className="df-confirmation-message-popup df-btn-grpdmodal"
          >
            <p>
              {t(
                "Are you sure you want to leave this page? You have some unsaved changes.",
              )}
            </p>
          </ForgotUserNameLeavePopup>
        </UiPopup>
      </div>
    </>
  );
};
